enum committeeProjectRole {
    principalReviewer = 1, //ผู้ทบทวนหลัก	Principal Reviewer
    committee = 2, //กรรมการ	Committee
    layperson = 3, //Layperson	Layperson
}
export default committeeProjectRole
